import Cookies from 'js-cookie';
import { get } from 'lodash';
import type { Locale } from '@fixter/i18n';
import partners from '$data/Partners';

import { getFixterMarketingCampaign, isFixterMarketingCampaignRunning } from './features/marketing';
import { getFeatureGlobalPromotionCampaignId, isFeatureGlobalPromotionActive } from './features';

const isBrowser = (): boolean => !!(typeof window !== 'undefined');

export const getPartnerCampaignIdFromCookieOrPathname = (pathname: string, partnerCookie = '') =>
  get(
    partners.find(({ slug }) => [pathname, partnerCookie].includes(slug)),
    'campaignId',
    ''
  );

const isParliamentHillPartner = (path: string, campaignId?: string | null): boolean =>
  !!(
    campaignId &&
    path.includes('parliament-hill') &&
    ['5059c97a-bd1d-4733-9515-e76e48a9c3f4', 'b918f9ab-4da8-406e-a439-54fedef4299e'].includes(campaignId)
  );

const isBoundlessPartner = (path: string, campaignId?: string | null): boolean =>
  !!(
    campaignId &&
    path.includes('boundless') &&
    ['51617d79-27e9-41b1-9ba5-68c7223d71c9', 'ea8b4686-b5e2-4725-85ea-b4b574c1643d'].includes(campaignId)
  );

const tierKaptenValues = ['bronze', 'silver', 'gold'];

const isKaptenPartner = (campaignId?: string | null, tierKapten?: string | null) =>
  !!(campaignId && campaignId.length > 0 && tierKapten && tierKaptenValues.includes(tierKapten));
export interface IPageType {
  readonly slug: string;
  readonly sku?: string;
  readonly type: string;
}

const getCampaignId = (
  pathname: string,
  locale: Locale,
  campaignId?: string | null,
  tierKapten?: string | null
): string | undefined | null => {
  if (!isBrowser) return undefined;
  const partnerCookie = Cookies.getJSON('fixterPartner');
  /**
   * partner campaignId from $data/Partners
   */

  const partnerCampaign = getPartnerCampaignIdFromCookieOrPathname(pathname, partnerCookie);
  if (partnerCampaign) return partnerCampaign;

  /**
   * Partners special cases
   */
  if (isParliamentHillPartner(pathname, campaignId)) return campaignId;
  if (isBoundlessPartner(pathname, campaignId)) return campaignId;
  if (isKaptenPartner(campaignId, tierKapten)) return campaignId;

  // Referral
  if (pathname.includes('/me/')) return campaignId;
  // Detect marketing campaign - overrides global campaign
  if (isFixterMarketingCampaignRunning()) return getFixterMarketingCampaign();
  // Detect global campaign
  if (isFeatureGlobalPromotionActive(locale)) return getFeatureGlobalPromotionCampaignId(locale);
  return undefined;
};

export default getCampaignId;
